
import { Component, Vue } from 'nuxt-property-decorator'

import AppLayout from '~/components/AppLayout.vue'
import AppHeader from '~/components/AppHeader'
import AppOfflineBar from '~/components/AppOfflineBar.vue'
import AppFooter from '~/components/AppFooter.vue'
import PageDynamicBanner from '~/components/banners/PageDynamicBanner'
import DealOfTheDay from '~/components/DealOfTheDay/DealOfTheDay.vue'
import AppLayoutOverlay from '~/components/AppLayoutOverlay/AppLayoutOverlay.vue'
import CookieBanner from '~/components/CookieBanner.vue'

@Component({
  components: {
    CookieBanner,
    AppLayoutOverlay,
    DealOfTheDay,
    AppLayout,
    AppHeader,
    PageDynamicBanner,
    AppFooter,
    AppOfflineBar,
  },
})
export default class DefaultLayout extends Vue {
  get headerType () {
    return this.localePath('black-april') === this.$route.path ? 'navigation-less' : 'default'
  }

  get headerTheme () {
    return this.localePath('black-april') === this.$route.path ? 'dark' : 'light'
  }

  get headerLogoPosition () {
    return this.localePath('black-april') === this.$route.path ? 'center' : 'left'
  }

  get isHeaderWithShadow () {
    return this.localePath('index') !== this.$route.path
  }

  get isShowPageBanner () {
    // Do not show the page banner for the Black April LP
    if (this.localePath('black-april') === this.$route.path) {
      return false
    }

    return this.localePath('index') !== this.$route.path
  }

  get keepAliveKey () {
    return this.$route.fullPath
  }

  created () {
    if (process.client) {
      this.$analytics.emarsys.init()
    }
  }
}
